import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const { userPhoneNumber, errors } = copy;

export const fields: IFormFields = [
  {
    name: "phoneNumber",
    label: userPhoneNumber.fields.phoneNumber,
    type: IFieldType.phone,
    validation: {
      required: errors.required,
    },
  },
  {
    name: "note",
    label: userPhoneNumber.fields.note.title,
    note: userPhoneNumber.fields.note.note,
    type: IFieldType.text,
  },
];
